import { colorToString, constraintColorInterpolator, ColorMapEntry, getCustomColorInterpolator, getColorScheme, ColorInterpolator as tlmdColorInterpolator, normalizeColorInterpolator} from '../util/color';

export type ColorInterpolator = (t:number) => string;

export const wrapTLMDInterpolator = (colorInterpolator: tlmdColorInterpolator, subDomain?:[number,number]): ColorInterpolator => {
	const normalizedColorInterpolator = normalizeColorInterpolator(colorInterpolator, subDomain);
	return (t: number) => colorToString( normalizedColorInterpolator(t));
}

export const colorInterpolator = (map: ColorMapEntry[], noAlpha = false, hideUnderflow = true, hideOverflow = false): ColorInterpolator => {
	let colorMapper = constraintColorInterpolator(getCustomColorInterpolator(map), noAlpha, hideUnderflow, hideOverflow, true);
	return (t: number) => colorToString(colorMapper(t));
}

export const colorScheme = (thresholds: number[], interpolator: tlmdColorInterpolator, noAlpha = false, hideUnderflow = true, hideOverflow = false): string[] => {
	return getColorScheme(constraintColorInterpolator(interpolator, noAlpha, hideUnderflow, hideOverflow, false), thresholds).map( color => colorToString(color))
}

